export const RECIEVE_DATA = "ReceiveData";
export const SUBSCRIBE = "Subscribe";